const crossConnectionsState = {
    crossConnections: undefined,
    interfaceCrossConnections: undefined,
    lockerCrossConnections: undefined,
    requestingCreateCrossConnection: false,
    requestingCrossConnections: false,
    requestingInterfaceCrossConnections: false,
    requestingLockerCrossConnections: false,
    requestingModifyCrossConnection: false,
    requestingRemoveCrossConnection: false,
    requestingSiteCrossConnections: false,
    siteCrossConnections: undefined
};
export default crossConnectionsState;
